$shm_showcase_component $mol_page
	entry_id \
	Code_demo $mol_text_code_demo
		source \
			\namespace $.$$ {
			\	export class Counter extends $mol_object {
			\		@ $mol_mem
			\		value( next = 0 ) { return next }
			\	}
			\}
	title <= component_title \
	tools /
		<= Close $mol_link
			hint \Закрыть пример
			arg * component null
			sub / <= Close_icon $mol_icon_close
	body <= demo_content /$mol_view
